import React from "react";

function PrivacyPolicyPage() {
  return (
    <div className="container mt-8">
      <h1 className="text-2xl font-bold">PRIVACY POLICY</h1>
      <p className="text-xl my-4">
        <strong>Effective Date:</strong> Jan, 01, 2024
      </p>

      <p>
        <strong>Magnum Car Rentals</strong> (“we,” “us,” or “our”) respects your
        privacy and is committed to protecting your personal information. This
        Privacy Policy outlines how we collect, use, and protect your
        information when you interact with our website, services, or
        communication platforms including SMS/text messages.
      </p>
      <br />
      <h2 className="text-xl font-semibold mb-2">1. Information We Collect</h2>
      <p>We may collect the following information:</p>
      <ul className="list-disc pl-6">
        <li>
          Name, email address, phone number, and driver's license information
        </li>
        <li>Billing and payment details</li>
        <li>Rental preferences and history</li>
        <li>Communication history, including SMS and email interactions</li>
      </ul>
      <br />
      <h3 className="text-lg font-semibold mb-2">
        2. How We Use Your Information
      </h3>
      <p>We use your information to:</p>
      <ul className="list-disc pl-6">
        <li>Confirm and manage your vehicle rentals</li>
        <li>
          Communicate important booking information (via email, SMS, or calls)
        </li>
        <li>Process payments and refunds</li>
        <li>Provide customer support</li>
        <li>Send promotional offers (only with your consent)</li>
      </ul>
      <br />
      <h3 className="text-lg font-semibold mb-2">3. Mobile/SMS Privacy</h3>
      <p>
        We{" "}
        <strong>
          do not share your mobile number or SMS information with any third
          parties or affiliates
        </strong>{" "}
        for marketing or promotional purposes. Your phone number is used solely
        for service-related communication (booking confirmations, instructions,
        etc.).
      </p>
      <br />
      <h3 className="text-lg font-semibold mb-2">4. Data Security</h3>
      <p>
        We implement security measures to protect your data from unauthorized
        access, misuse, or disclosure.
      </p>
      <br />
      <h2 className="text-xl font-semibold mb-2">5. Your Choices</h2>
      <p>
        You may opt out of receiving promotional text messages at any time by
        replying “STOP.” For assistance, reply “HELP” or contact us directly.
      </p>
      <br />
      <h2 className="text-xl font-semibold mb-2">6. Changes to This Policy</h2>
      <p>
        We may update this policy from time to time. The latest version will
        always be available on our website.
      </p>
      <br />
      <h2 className="text-xl font-semibold mb-2">7. Contact Us</h2>
      <p>If you have any questions about this policy, please contact us at:</p>
      <br />
      <p>
        <strong>Email:</strong> info@magnumcarrentals.com
      </p>
      <p>
        <strong>Address:</strong> 2231 E Oakton Street, Arlington heights, IL,
        60005
      </p>
      <br />
      <hr style={{ borderColor: "black" }} />
      <h1 className="text-2xl font-bold mt-4">TERMS OF SERVICE</h1>
      <p className="text-xl my-4">
        <strong>Effective Date:</strong> Jan, 01, 2024
      </p>

      <p>
        Welcome to <strong>Magnum Car Rentals</strong>. These Terms of Service
        ("Terms") govern your use of our website, rental services, and
        communications including SMS/text messaging.
      </p>
      <br />
      <h2 className="text-xl font-semibold mb-2">1. Rental Agreement</h2>
      <p>
        By booking a vehicle with us, you agree to abide by all rental terms,
        mileage limits, insurance requirements, and vehicle care expectations
        outlined at the time of booking.
      </p>
      <br />
      <h3 className="text-lg font-semibold mb-2">2. Eligibility</h3>
      <p>
        You must be at least 21 years old with a valid driver’s license to rent
        a vehicle from Magnum Car Rentals.
      </p>
      <br />
      <h3 className="text-lg font-semibold mb-2">3. Payments</h3>
      <p>
        All rentals must be paid in full before vehicle pickup. You may be
        required to provide a refundable deposit depending on the vehicle or
        your rental history.
      </p>
      <br />
      <h3 className="text-lg font-semibold mb-2">4. SMS/Text Messaging</h3>
      <p>
        By providing your mobile number, you consent to receive SMS messages
        regarding:
      </p>
      <ul className="list-disc pl-6">
        <li>Booking confirmations</li>
        <li>Pickup/drop-off instructions</li>
        <li>Updates, reminders, and promotional offers</li>
      </ul>
      <br />
      <p>
        You may opt out at any time by replying “STOP.” Message and data rates
        may apply. We do{" "}
        <strong>
          not share your phone number or text history with any third party.
        </strong>
      </p>
      <br />
      <h2 className="text-xl font-semibold mb-2">5. Prohibited Uses</h2>
      <p>
        Vehicles may not be used for illegal activity, racing, towing, or
        subleasing. Violations may result in penalties or permanent suspension
        of rental privileges.
      </p>
      <br />
      <h2 className="text-xl font-semibold mb-2">6. Damages & Liability</h2>
      <p>
        You are responsible for any damage incurred during your rental period
        unless covered by insurance. Additional fees may apply for excessive
        wear, smoking in vehicles, or late returns.
      </p>
      <br />
      <h2 className="text-xl font-semibold mb-2">7. Termination</h2>
      <p>
        We reserve the right to cancel or terminate rentals for any violation of
        these terms or misuse of our vehicles.
      </p>
      <br />
      <h2 className="text-xl font-semibold mb-2">8. Modifications</h2>
      <p>
        We may update these Terms at any time. Continued use of our services
        constitutes acceptance of any changes.
      </p>
      <br />
      <h2 className="text-xl font-semibold mb-2">9. Contact</h2>
      <p>If you have questions, please contact:</p>
      <br />
      <p>
        <strong>Email:</strong> info@magnumcarrentals.com
      </p>
      <p>
        <strong>Address:</strong> 2231 E Oakton Street, Arlington heights, IL,
        60005
      </p>
      <br />
    </div>
  );
}

export default PrivacyPolicyPage;
